// libraries
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Table, Tooltip } from 'antd';
import { CommentOutlined, MessageOutlined, CheckOutlined, CameraOutlined } from '@ant-design/icons';
import moment from 'moment';

// resources
import { SharedTable } from '../../../shared/table';
import { txt } from '../../../../locales/i18n';

export function PostListContentDesktop(props: any): JSX.Element {
	const [showDescriptionColumn, setShowDescriptionColumn] = useState<boolean>(false);
	const [isCompactView, setIsCompactView] = useState<boolean>(false);

	const history = useHistory();
	const location = useLocation();

	useEffect(() => {
		setShowDescriptionColumn(location.search.includes('status=good'));
		setIsCompactView(location.search.includes('compact=true'));
	}, [location]);

	function renderDate(value: string): string {
		const format: string = 'ddd DD/MM-YY HH:mm';
		return moment(value).format(format);
	}

	function renderCheckmark(value: number): JSX.Element | null {
		if (Boolean(value) === true) {
			return <CheckOutlined />;
		}

		return null;
	}

	function renderNumber(value: number): number | null {
		return value || null;
	}

	function handleOnRow(record: Record<string, any>): Record<string, any> {
		return {
			onClick: () => {
				history.replace({ hash: String(record.id), search: location.search });
				history.push(`/posts/${record.id}`);
			},
		};
	}

	return (
		<SharedTable
			rowKey="id"
			loading={props.loading}
			dataSource={props.dataSource}
			onRow={handleOnRow}
		>
			<Table.Column dataIndex="id" title="ID" width="6em" />
			<Table.Column dataIndex="title" title={txt('global.title')} width="12em" ellipsis />

			{showDescriptionColumn && (
				<Table.Column
					dataIndex="description"
					title={txt('global.description')}
					width="24em"
					ellipsis
				/>
			)}

			<Table.Column
				dataIndex="image"
				title={<CameraOutlined />}
				width="6ch"
				render={renderCheckmark}
				align="center"
			/>

			{isCompactView === false && (
				<>
					<Table.Column
						dataIndex="conversations"
						title={
							<Tooltip title={txt('global.conversations')}>
								<CommentOutlined />
							</Tooltip>
						}
						width="8ch"
						align="center"
						render={renderNumber}
					/>

					<Table.Column
						dataIndex="messages"
						title={
							<Tooltip title={txt('global.messages')}>
								<MessageOutlined />
							</Tooltip>
						}
						width="8ch"
						align="center"
						render={renderNumber}
					/>
				</>
			)}

			<Table.Column
				dataIndex="universe"
				title={txt('global.universe')}
				width="12em"
				ellipsis
			/>

			<Table.Column
				dataIndex="created"
				title={txt('global.created')}
				render={renderDate}
				width="16em"
			/>

			<Table.Column dataIndex="username" title={txt('global.user')} width="12em" ellipsis />
			<Table.Column dataIndex="email" title="Email" width="12em" ellipsis />
			<Table.Column dataIndex="age" title={txt('global.age')} width="6em" align="center" />
			<Table.Column
				dataIndex="municipality"
				title={txt('global.municipality')}
				width="12em"
				ellipsis
			/>

			<Table.Column
				dataIndex="approved"
				title={<CheckOutlined />}
				width="4em"
				render={renderCheckmark}
				align="center"
			/>
		</SharedTable>
	);
}
